const buildDate: string = import.meta.env.VITE_BUILD_DATE ?? 'unknown';

export function Privacy() {
  return (
    <div class="max-w-md mx-auto px-4 py-6 space-y-6">
      <h1 class="text-xl font-bold text-hudson-navy">Privacy</h1>
      <p class="text-xs text-body/70">Last updated {buildDate}</p>

      <section class="space-y-3">
        <h2 class="text-base font-semibold text-hudson-navy">We collect nothing</h2>
        <p class="text-sm text-body/80 leading-relaxed">
          There is no server. Your data lives on this device only. We have no analytics,
          no error tracking, no telemetry of any kind. If we did, it would contradict our
          brand promise.
        </p>
      </section>

      <section class="space-y-3 border-t border-card-border pt-4">
        <h2 class="text-base font-semibold text-hudson-navy">PIPEDA</h2>
        <p class="text-sm text-body/80 leading-relaxed">
          The Personal Information Protection and Electronic Documents Act (PIPEDA) governs
          commercial collection of personal information. This app does not collect, store,
          transmit, or process any personal information on Hudson Bay Finance servers
          because we operate no servers.
        </p>
      </section>

      <section class="space-y-3 border-t border-card-border pt-4">
        <h2 class="text-base font-semibold text-hudson-navy">CASL</h2>
        <p class="text-sm text-body/80 leading-relaxed">
          Canada's Anti-Spam Legislation (CASL) governs commercial electronic messages.
          We send none from this app.
        </p>
      </section>

      <section class="space-y-3 border-t border-card-border pt-4">
        <h2 class="text-base font-semibold text-hudson-navy">Supplier of record</h2>
        <p class="text-sm text-body/80 leading-relaxed">
          Hudson Bay Finance is operated by Mo (GST/HST registered in Canada effective
          September 14, 2025). Contact:{' '}
          <a
            href="mailto:hbfproducts1@gmail.com"
            class="text-hudson-navy underline focus:outline-none focus:ring-2 focus:ring-hudson-navy rounded"
          >
            hbfproducts1@gmail.com
          </a>
        </p>
      </section>
    </div>
  );
}
